<style lang="scss">
$leftWidth: 220px;
.goods-check-page {
  .el-form-item__content, .el-form-item__label {
    line-height: 24px !important;
  }

  .el-form-item__label {
    line-height: 24px !important;
  }

  .content-part {
    .el-form-item {
      margin-bottom: 0px;

      &__label {
        line-height: 24px;
      }
    }

    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }
}

.goods-check-page {
  .content-part {
    /* 谷歌 */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }

    /* 火狐 */
    input {
      -moz-appearance: textfield;
    }
  }
}
</style>
<template>
  <div class="goods-check-page">
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>查看资源码</h3>
        <div class="hide-content show-content" v-if="form">
          <el-form ref="form" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item style="line-height: 24px !important;" label="货品名称" prop="goodsName">
              {{ form.productName }}
            </el-form-item>
            <el-form-item label="所属单位" prop="orgId" v-show="platform">
              {{ form.orgName }}
            </el-form-item>
            <el-form-item label="产品编码" prop="productCode">
              {{ form.productCode }}
            </el-form-item>
            <el-form-item label="子类编码" prop="productSubclassCode">
              {{ form.productSubclassCode }}
            </el-form-item>
            <el-form-item label="剂型" prop="productDosage">
              {{ form.productDosage }}
            </el-form-item>
            <el-form-item label="剂型规格" prop="productSpecification">
              {{ form.productSpecification }}
            </el-form-item>
            <el-form-item label="包装规格" prop="productPackingSpecification">
              {{ form.productPackingSpecification }}
            </el-form-item>
            <el-form-item label="包装单位" prop="productPackingUnit">
              {{ form.productPackingUnit || '暂无' }}
            </el-form-item>
            <el-form-item label="备注" prop="productRemark">
              {{ form.productRemark || '暂无' }}
            </el-form-item>
          </el-form>
        </div>
        <div v-if="checkTable">
          <el-table :data="tabledatas" border>
            <el-table-column :label="titleList[0].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.resourceCode"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.resourceCode }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[1].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.packingLevel"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packingLevel }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[2].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.packingCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packingCount }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[4].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.packageRatio"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packageRatio }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[5].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.codeVersion"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.codeVersion }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[6].label">
              <template slot-scope="scope">
                <el-input :disabled="true" placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.maxCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.maxCount }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[7].label">
              <template slot-scope="scope">
                <el-input :disabled="true" placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.currentCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.currentCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="55">
              <template slot-scope="scope">
                <el-button :loading="doing" v-if="!scope.row.show" @click="handleTableDelete(scope)"
                           v-show="scope.row.currentCount===0">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {goodsManage, resourceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';

export default {
  props: {
    defaultIndex: Number,
    title: String,
    platform: {
      type: Boolean,
      default: false
    },
    form: Object,
    checkTable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [methodsMixin],
  data() {
    return {
      tabledatas: [],
      titleList: [
        {label: '资源编码', value: 'resourceCode'},
        {label: '包装层级', value: 'packingLevel'},
        {label: '层级件数', value: 'packingCount'},
        {label: '包装单位', value: 'packingUnit'},
        {label: '包装比例', value: 'packageRatio'},
        {label: '追溯码版本号', value: 'codeVersion'},
        {label: '最大允许申请数量', value: 'maxCount'},
        {label: '当前已经申请数量', value: 'currentCount'},
      ],
      orgRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      platformRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        orgId: {required: true, message: '请选择所属单位', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      // rules: {
      //   goodsId: {required: true, message: '请选择货品', trigger: 'change'},
      //   // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
      //   productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
      //   productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
      //   productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
      //   productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
      //   productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
      // },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    },
    rules() {
      return this.platform ? this.platformRules : this.orgRules
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
    form: {
      handler(val, oldVal) {
        if (!val) return;
        if (!val.productSubclassId) return;
        if (!this.checkTable) return;
        if (oldVal && oldVal.productSubclassId && val.productSubclassId === oldVal.productSubclassId) return;
        resourceCode.queryCode({productSubclassId: val.productSubclassId}).then(res => {
          let newData = JSON.parse(JSON.stringify(res.data));
          newData.map(m => {
            m.show = false
          })
          this.tabledatas = [
            ...newData
          ]
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
        })
      }, immediate: true, deep: true
    }
  },
  methods: {
    resetTable() {
      this.tabledatas = []
    },
    handleTableDelete(scope) {
      this.$confirm('是否确认删除资源码【'+scope.row.resourceCode+'】？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.doing = true;
        resourceCode.deleteCode(scope.row.resourceCodeId).then(res => {
          this.tabledatas.splice(scope.$index, 1);
          this.doing = false;
          this.$notify.success({message: '删除成功'});
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
          this.doing = false;
        })
      });

    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    }
  }
};
</script>
